import React from "react";
import { useSelector } from "react-redux";
import { Card, Row, Col } from "react-bootstrap";
import { formatCurrency } from "../../../utils/currency";
import {
  LuSend,
  LuUsers,
  LuCircleCheck,
  LuShoppingCart,
  LuTrendingUp,
  LuTrendingDown,
} from "react-icons/lu";

export default function DashboardInsight() {
  const { analytics } = useSelector((state) => state.invoice);
  const stats = analytics?.dashboardStats || {};

  const cards = [
    {
      label: "Invoices Sent",
      value: stats?.totalsentinvoice || 0,
      icon: <LuSend size={16} />,
      color: "#28B0C4",
      bg: "#e8f8fb",
      trend: { value: "+12.5%", up: true },
      format: "number",
    },
    {
      label: "Customers Added",
      value: stats?.totalcustomer || 0,
      icon: <LuUsers size={16} />,
      color: "#6366f1",
      bg: "#ede9fe",
      trend: { value: "+5.2%", up: true },
      format: "number",
    },
    {
      label: "Invoices Paid",
      value: stats?.totalpaidinvoice || 0,
      icon: <LuCircleCheck size={16} />,
      color: "#10b981",
      bg: "#d1fae5",
      trend: { value: "-2.1%", up: false },
      format: "number",
    },
    {
      label: "Products Sold",
      value: stats?.totalproductsold || 0,
      icon: <LuShoppingCart size={16} />,
      color: "#f59e0b",
      bg: "#fef3c7",
      trend: { value: "+8.4%", up: true },
      format: "number",
    },
  ];

  const currency = useSelector((state) => state.business?.currencyContext?.currency || 'CAD');

  const formatValue = (card) => {
    if (card.format === "currency") return formatCurrency(card.value, currency);
    return card.value.toLocaleString();
  };

  return (
    <Row className="g-3 mb-4">
      {cards.map((card) => (
        <Col key={card.label} xs={12} sm={6} xxl={3}>
          <Card className="border-0 shadow-sm rounded-4 h-100" style={{ padding: "14px 16px" }}>
            <div className="d-flex align-items-start justify-content-between">

              {/* Icon */}
              <div
                className="rounded-3 d-flex align-items-center justify-content-center"
                style={{
                  width: 34,
                  height: 34,
                  background: card.bg,
                  color: card.color,
                  flexShrink: 0,
                }}
              >
                {card.icon}
              </div>

              {/* Trend badge */}
              <span
                className={`d-inline-flex align-items-center gap-1 rounded-pill px-2 py-1 fw-semibold`}
                style={{
                  fontSize: "11px",
                  background: card.trend.up ? "#d1fae5" : "#fee2e2",
                  color: card.trend.up ? "#10b981" : "#ef4444",
                }}
              >
                {card.trend.up
                  ? <LuTrendingUp size={11} />
                  : <LuTrendingDown size={11} />}
                {card.trend.value}
              </span>
            </div>

            {/* Value + Label */}
            <div className="mt-3">
              <div
                className="fw-bold text-dark"
                style={{ fontSize: "20px", lineHeight: 1.2 }}
              >
                {formatValue(card)}
              </div>
              <div className="text-muted fw-medium mt-1" style={{ fontSize: "12px" }}>
                {card.label}
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
}